import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const COLORS = ['#fcd34d', '#6ee7b7', '#60a5fa', '#f87171', '#c084fc', '#fb923c'];
const SHAPES = ['circle', 'square', 'triangle'];

const ConfettiParticle = ({ id, onComplete }) => {
  const color = COLORS[Math.floor(Math.random() * COLORS.length)];
  const shape = SHAPES[Math.floor(Math.random() * SHAPES.length)];
  
  // Radial burst physics
  const [physics] = useState(() => {
    const angle = Math.random() * Math.PI * 2; // Random 360 degree angle
    const velocity = Math.random() * 600 + 400; // Burst strength
    return {
      targetX: Math.cos(angle) * velocity,
      targetY: Math.sin(angle) * velocity,
      rotate: Math.random() * 720 - 360,
      size: Math.random() * 10 + 6,
      duration: Math.random() * 1.5 + 1.5
    };
  });

  return (
    <motion.div
      initial={{ 
        x: '50vw', 
        y: '50vh', 
        rotate: 0,
        opacity: 1,
        scale: 0 
      }}
      animate={{ 
        x: `calc(50vw + ${physics.targetX}px)`,
        y: `calc(50vh + ${physics.targetY}px)`,
        rotate: physics.rotate,
        opacity: [1, 1, 0],
        scale: [0, 1.2, 0.5]
      }}
      transition={{ 
        duration: physics.duration, 
        ease: [0.1, 0.8, 0.3, 1] // Fast start, slow end
      }}
      onAnimationComplete={onComplete}
      style={{
        position: 'absolute',
        width: physics.size,
        height: physics.size,
        backgroundColor: color,
        borderRadius: shape === 'circle' ? '50%' : shape === 'triangle' ? '0' : '2px',
        clipPath: shape === 'triangle' ? 'polygon(50% 0%, 0% 100%, 100% 100%)' : 'none',
        pointerEvents: 'none',
        zIndex: 9998,
        boxShadow: '0 0 10px rgba(0,0,0,0.1)'
      }}
    />
  );
};

export default function Celebration() {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Large initial burst
    const initialBurst = Array.from({ length: 120 }).map((_, i) => ({
      id: `initial-${i}-${Math.random()}`
    }));
    setParticles(initialBurst);

    // Follow-up mini-bursts for 3 seconds
    const interval = setInterval(() => {
      setParticles(prev => {
        if (prev.length > 200) return prev;
        return [...prev, { id: `extra-${Date.now()}-${Math.random()}` }];
      });
    }, 80);

    const timeout = setTimeout(() => clearInterval(interval), 4000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', overflow: 'hidden', zIndex: 9998 }}>
      <AnimatePresence>
        {particles.map(p => (
          <ConfettiParticle 
            key={p.id} 
            onComplete={() => setParticles(prev => prev.filter(item => item.id !== p.id))} 
          />
        ))}
      </AnimatePresence>
    </div>
  );
}
